//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { clone } from "lodash";

var UserAddress = function UserAddress() {
    return import( /* webpackChunkName: "js/checkout/user-address" */'./UserAddress.vue');
};
var AllAddresses = function AllAddresses() {
    return import( /* webpackChunkName: "js/checkout/all-addresses" */'./AllAddresses.vue');
};
var SearchAddress = function SearchAddress() {
    return import( /* webpackChunkName: "js/checkout/search-address" */'./SearchAddress.vue');
};
var MultipleAddress = function MultipleAddress() {
    return import( /* webpackChunkName: "js/checkout/multiple-address" */'./MultipleAddress.vue');
};

export default {

    props: {
        user: {
            required: true,
            default: null
        },
        seladd: {
            required: true,
            default: 0
        }
    },

    components: {
        UserAddress: UserAddress,
        AllAddresses: AllAddresses,
        SearchAddress: SearchAddress,
        MultipleAddress: MultipleAddress
    },

    data: function data() {
        return {
            addressbook: [],
            shippingSource: 'user',
            address: clone(this.user),
            newAddress: false,
            addressName: '',
            countries: [],
            selectedAdd: this.seladd,
            addressNameClass: {
                'form-group': true,
                'has-error': false
            }
        };
    },


    methods: {
        addressChange: function addressChange(_ref) {
            var address = _ref.address,
                isNew = _ref.isNew,
                addressId = _ref.addressId;

            if (address.country) {
                address.countryName = this.countries.filter(function (obj) {
                    return obj.id == address.country;
                });
                address.countryName = address.countryName[0].name;
            }
            this.address = address;
            this.addressName = address.name;
            this.newAddress = isNew;
            this.selectedAdd = addressId;
        },
        validate: function validate() {

            var isValid = this.addressName.length != 0 || this.shippingSource === 'multiple';
            this.addressNameClass['has-error'] = this.addressName.length == 0 || this.shippingSource === 'multiple';

            // if (!this.$refs.allAddresses.validate()) {
            //     isValid = false;
            // }


            return isValid;
        }
    },

    computed: {
        deliveryAddress: function deliveryAddress() {

            var address = clone(this.address);
            address.name = this.addressName;

            return address;
        },
        addressNameValid: function addressNameValid() {
            return true;
        }
    },

    created: function created() {
        var _this = this;

        this.address = clone(this.user);
        this.addressName = this.address.name;
        this.countries = App.countries;
        App.event.listen('countries.loaded', function (countries) {
            return _this.countries = countries;
        });
        App.event.listen('shipping.source.changed', function (_ref2) {
            var who = _ref2.who;
            _this.shippingSource = who;
        });

        // new Form().get('/api/addressbook/all')
        //     .then(addressbook => {
        //         this.addressbook = addressbook;
        //     });

        App.event.listen('address-added', function (address) {
            _this.addressbook.push(address);
        });
    },


    watch: {

        deliveryAddress: {
            handler: function handler() {
                App.event.fire('shipping.changed', this.deliveryAddress);
            },
            deep: true
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/shipping-address/components/ShippingAddress.vue
// module id = +HnL
// module chunks = 4